import homePortrait from "../assets/accion-pic.jpeg";
import blogLogo from "../assets/MMK10.svg";
import signatureLoaderLogo from "../assets/MMK10.png";
import signatureLoaderLogoOverlay from "../assets/blank_white.png";
import homeIcon from "../assets/mmk-favicon-4.png";
import suggestorIcon from "../assets/mmk-favicon-design.png";
import treeGif from "../assets/treeGif.gif";
import silverSpiralGif from "../assets/silver-spiral.gif";
import suggestorBackgroundGif from "../assets/codeGif.gif";
import animationDiamondGif from "../assets/animation-diamond.gif";
import bloodEffectGif from "../assets/blood-effect.gif";
import smokeTitleGif from "../assets/smoke-title.gif";
import spiralGif from "../assets/spiralGif.gif";

const publicPath = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

// Request Home assets first, followed by the AI Suggestor's assets.
const priorityAssetUrls = [
  homePortrait, // accion-pic.jpeg: the Home hero image is preloaded first.
  blogLogo,
  signatureLoaderLogo,
  signatureLoaderLogoOverlay,
  homeIcon,
  treeGif,
  silverSpiralGif,
  suggestorIcon,
  suggestorBackgroundGif,
];

// These page GIFs begin after the priority assets finish or the five-second
// startup window expires. They are fetched one by one at low network priority.
const deferredGifUrls = [
  animationDiamondGif,
  bloodEffectGif,
  spiralGif,
  `${publicPath}/general-hustle.gif`,
  smokeTitleGif,
];

let priorityAssetsPromise: Promise<void> | undefined;
let priorityWindowPromise: Promise<void> | undefined;
let deferredAssetsPromise: Promise<void> | undefined;
let backgroundLoadingPromise: Promise<void> | undefined;

const preloadImage = (src: string, priority: "high" | "low") =>
  new Promise<void>((resolve) => {
    const image = new Image();
    let settled = false;

    const settle = () => {
      if (settled) return;
      settled = true;
      image.onload = null;
      image.onerror = null;
      resolve();
    };

    image.setAttribute("fetchpriority", priority);
    image.decoding = "async";
    image.onload = settle;
    image.onerror = settle;
    image.src = src;

    if (image.complete) settle();
  });

export const preloadPriorityAssets = () => {
  if (!priorityAssetsPromise) {
    priorityAssetsPromise = Promise.all(
      priorityAssetUrls.map((src) => preloadImage(src, "high"))
    ).then(() => undefined);
  }

  return priorityAssetsPromise;
};

export const waitForPriorityAssetsOrDeadline = () => {
  if (!priorityWindowPromise) {
    const priorityAssets = preloadPriorityAssets();
    priorityWindowPromise = new Promise<void>((resolve) => {
      let settled = false;
      let deadline: number | undefined;
      const finish = () => {
        if (settled) return;
        settled = true;
        if (deadline !== undefined) window.clearTimeout(deadline);
        resolve();
      };
      deadline = window.setTimeout(finish, 5000);

      void priorityAssets.then(finish);
    });
  }

  return priorityWindowPromise;
};

export const preloadDeferredAssets = () => {
  if (!deferredAssetsPromise) {
    deferredAssetsPromise = deferredGifUrls.reduce(
      (queue, src) => queue.then(() => preloadImage(src, "low")),
      Promise.resolve()
    );
  }

  return deferredAssetsPromise;
};

export const startBackgroundAssetLoading = () => {
  if (!backgroundLoadingPromise) {
    backgroundLoadingPromise = waitForPriorityAssetsOrDeadline().then(
      preloadDeferredAssets
    );
  }

  return backgroundLoadingPromise;
};
